import OutsideClickHandler from "react-outside-click-handler";
import ReactDOM from "react-dom";
import { Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
const ModalPhone = ({
  setVerifyEdit,
  handleSubmit1,
  onSubmit1,
  errors1,
  verifyEdit,
  control1,
  inputRef,
  register1,
  isLoader1,
}) => {
  return ReactDOM.createPortal(
    <div data-reactroot>
      <div className="am-popup-mask" />
      <div
        className={"am-popup-wrap EN new-date-picker bet15bdtf6"}
        role="dialog"
      >
        <OutsideClickHandler
          onOutsideClick={() => {
            setVerifyEdit({ status: false });
          }}
        >
          <div role="document" className="am-popup am-popup-slide-up">
            <div className="am-popup-content">
              <button aria-label="Close" className="am-popup-close">
                <span className="am-popup-close-x" />
              </button>
              <div className="am-popup-body">
                <Form onSubmit={handleSubmit1(onSubmit1)}>
                  {" "}
                  <div
                    className="vc-scroll-container "
                    style={{ height: "100%" }}
                  >
                    <div className="vc-v2-container ">
                      {verifyEdit?.phoneStatus == "add" && (
                        <>
                          <div className="ranndom-container">
                            <div className="vc-v2-title pay-name ">
                              Mobile Number
                            </div>
                            <div className="vc-v2-input no-border">
                              <div style={{height:".8rem",border:"none"}} className="inputCon">
                                <Controller
                                  className="form-group d-flex"
                                  control={control1}
                                  name="mobile"
                                  rules={{
                                    required: "Please enter mobile number.",
                                    validate: (value) => {
                                      let inputValue = value
                                        ?.toString()
                                        ?.slice(
                                          inputRef?.current?.state
                                            ?.selectedCountry?.countryCode
                                            ?.length,
                                          value?.length,
                                        );
                                      if (inputValue?.length < 10) {
                                        return "Mobile number must contain 10 digit";
                                      } else if (inputValue?.length > 12) {
                                        return "Mobile number should not exceed 12 digit";
                                      } else {
                                        return true;
                                      }
                                    },
                                  }}
                                  render={({ field: { ref, ...field } }) => (
                                    <>
                                      <PhoneInput
                                        {...field}
                                        inputExtraProps={{
                                          ref,
                                          required: true,
                                          autoFocus: true,
                                        }}
                                        ref={inputRef}
                                        inputStyle={{
                                          width: "100%",
                                          height: "38px",
                                        }}
                                        country={"bd"}
                                        enableSearch
                                        countryCodeEditable={false}
                                      />
                                    </>
                                  )}
                                />
                              </div>{" "}
                              {errors1?.mobile?.message && (
                                <div
                                  className="vc-tips"
                                  style={{ paddingTop: "5px" }}
                                >
                                  <div
                                    className="wysiwyg"
                                    style={{
                                      fontSize: "12px",
                                      paddingBottom: "0",
                                    }}
                                  >
                                    * {errors1?.mobile?.message}
                                  </div>
                                </div>
                              )}
                            </div>{" "}
                          </div>
                        </>
                      )}

                      <div className="ranndom-container">
                        <div className="vc-v2-title pay-name ">Password</div>
                        <div className="vc-v2-input no-border">
                          <div className="inputCon">
                            <input
                              type="text"
                              inputMode="text"
                              style={{ width: "100%" }}
                              className="inputBase"
                              placeholder="Enter password"
                              {...register1("verificationCode", {
                                required: "Please enter password",
                              })}
                            />
                          </div>{" "}
                          {errors1?.verificationCode?.message && (
                            <div
                              className="vc-tips"
                              style={{ paddingTop: "5px" }}
                            >
                              <div
                                className="wysiwyg"
                                style={{ fontSize: "12px", paddingBottom: "0" }}
                              >
                                * {errors1?.verificationCode?.message}
                              </div>
                            </div>
                          )}
                        </div>{" "}
                      </div>

                      <div className=" vc-v2-submit">
                        <button
                          disabled={isLoader1}
                          type="submit"
                          style={{
                            background: "transparent",
                            border: "none",
                            color: "white",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    </div>,
    document.getElementById("overlay"),
  );
};

export default ModalPhone;
